import { getAxiosInstance } from "./axiosInstance";

/* ---------------------------------------
   Safe Custody - Factory / Manufacturer / Dealer
--------------------------------------- */

// List devices eligible for Safe Custody
const safeCustodyEligible = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/eligible/",
        data
    );
};

// List devices currently in Safe Custody
const safeCustodyInCustody = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/in-custody/",
        data
    );
};

// Send devices to Safe Custody
const safeCustodyRequest = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/request/",
        data
    );
};

// Request devices back to Normal
const safeCustodyReturnRequest = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/return-request/",
        data
    );
};


/* ---------------------------------------
   Safe Custody - eSIM Manager
--------------------------------------- */

// List Safe Custody + Return requests
const safeCustodyList = (data = {}) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/list/",
        data
    );
};

// Approve Safe Custody request
const safeCustodyApprove = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/approve/",
        data
    );
};

// Approve Return-to-Normal request
const safeCustodyApproveReturn = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/safe-custody/approve-return/",
        data
    );
};


const SafeCustodyServices = {
    safeCustodyEligible,
    safeCustodyInCustody,
    safeCustodyRequest,
    safeCustodyReturnRequest,

    safeCustodyList,
    safeCustodyApprove,
    safeCustodyApproveReturn,
};

export default SafeCustodyServices;
